import { Controller } from '@hotwired/stimulus';

// Lets a link with data-turbo-frame="X" act as a toggle:
// - First click: lets Turbo load the response into <turbo-frame id="X">.
// - Second click: clears the frame so the panel collapses.
// The action must run in capture phase to fire before Turbo's click handler.
export default class extends Controller {
  toggle(event) {
    const frameId = this.element.dataset.turboFrame;
    if (!frameId) return;

    const frame = document.getElementById(frameId);
    if (!frame) return;

    if (frame.childElementCount > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      frame.innerHTML = '';
      frame.removeAttribute('src');
    }
  }
}
